import { Form } from '@/lib/classes/Form'
import { ValidationType } from '../types/validationType'
import { GuestNewsFormType } from '../types/GuestNewsFormType'
import { fetchUrlAndConvertToFiles } from '@/services/generalDataServices'
import { ImageType } from '@/app/types/newsType'
import { TFunction } from 'i18next'
import { validateEmail } from './validationUtils'

export class GuestNewsFormUtils extends Form<GuestNewsFormType> {
  constructor(guestNewsForm: GuestNewsFormType, t?: TFunction) {
    const validations: ValidationType = {
      language: [
        {
          condition: guestNewsForm?.language?.id == -1,
          message: 'Please Select Language',
        },
      ],
      origin: [
        {
          condition: guestNewsForm?.origin?.id == -1,
          message: 'Please Select Country',
        },
      ],
      company: [
        {
          condition: guestNewsForm?.company == '',
          message: 'Please Enter Company Name',
        },
      ],
      phone: [
        {
          condition: guestNewsForm?.phone == '',
          message: 'Please Enter Phone Number',
        },
      ],
      name: [
        {
          condition:
            guestNewsForm?.firstName == '' ||
            guestNewsForm?.lastName == '' ||
            guestNewsForm?.honorific?.id == -1,
          message: 'Please fill in all fields',
        },
      ],
      email: [
        {
          condition:
            !guestNewsForm?.requestCallBack &&
            (guestNewsForm?.email == '' ||
              !validateEmail(guestNewsForm?.email)),
          message: 'Please Enter Email Address',
        },
      ],
      title: [
        {
          condition:
            !guestNewsForm?.requestCallBack && guestNewsForm?.title == '',
          message: 'Please Enter Title',
        },
      ],
      caption: [
        {
          condition:
            !guestNewsForm?.requestCallBack && guestNewsForm?.caption == '',
          message: 'Please Enter Abstract',
        },
      ],
      preferredTime: [
        {
          condition:
            guestNewsForm?.requestCallBack &&
            guestNewsForm?.preferredTime == '',
          message: 'Please Enter Preferred Time',
        },
      ],
    }
    const serverValidations: ValidationType = {}
    super(
      guestNewsForm,
      validations,
      serverValidations,
      guestNewsForm?.isFormSubmitted,
      t
    )
  }

  async formDataForRequestBody(): Promise<FormData> {
    const formData = new FormData()
    const formValues = this.formData

    formData?.append(
      'news_request[request_callback]',
      String(formValues?.requestCallBack)
    )

    if (formValues?.origin?.id != -1) {
      formData?.append(
        'news_request[origin_id]',
        String(formValues?.origin?.id)
      )
      formData?.append(
        'news_request[origin_type]',
        String(formValues?.origin?.other?.origin_type)
      )
    }

    if (formValues?.language?.id != -1) {
      formData?.append(
        'news_request[language_id]',
        String(formValues?.language?.id)
      )
    }
    if (formValues?.phone) {
      formData?.append('news_request[phone]', String(formValues?.phone))
    }
    if (formValues?.phoneCodeId) {
      formData?.append(
        'news_request[phone_code_id]',
        String(formValues?.phoneCodeId?.id)
      )
    }
    if (formValues?.firstName) {
      formData?.append(
        'news_request[first_name]',
        String(formValues?.firstName)
      )
    }
    if (formValues?.lastName) {
      formData?.append('news_request[last_name]', String(formValues?.lastName))
    }
    if (formValues?.honorific) {
      formData?.append(
        'news_request[honorific]',
        String(formValues?.honorific?.value)
      )
    }
    if (formValues?.company) {
      formData?.append('news_request[company]', String(formValues?.company))
    }

    // if send a News
    if (formValues?.requestCallBack) {
      formData?.append(
        'news_request[preferred_time]',
        formValues?.preferredTime
      )
      return formData
    }

    // else to be called by phone
    if (formValues?.email) {
      formData?.append('news_request[email]', String(formValues?.email))
    }

    if (formValues?.title) {
      formData?.append('news_request[title]', String(formValues?.title))
    }

    if (formValues?.caption) {
      formData?.append('news_request[caption]', String(formValues?.caption))
    }
    if (formValues?.description) {
      formData?.append(
        'news_request[description]',
        String(formValues?.description)
      )
    }
    const newImages =
      formValues?.images?.filter((item: ImageType) => item?.id == -1) || []
    let imageIdx = 0

    for (const item of newImages) {
      const img = await fetchUrlAndConvertToFiles(item?.url)
      formData.append(
        `news_request[images_attributes][${imageIdx}][image]`,
        img[0]
      )
      item?.redirect_url &&
        formData.append(
          `news_request[images_attributes][${imageIdx}][redirect_url]`,
          String(item?.redirect_url)
        )
      imageIdx++
    }

    return formData
  }
}
